import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getRestaurantsOrHotels } from "../../../api/user";
import { useQuery } from "@tanstack/react-query";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import Menu from "../Menu";
import BookTable from "../BookTable";
import { useTranslation } from "../../../hooks/useTranslation";

const RestaurantOrdering = ({filterType}) => {
  const { t } = useTranslation();
  const homeCopy = t("home") || {};
  const aiCopy = homeCopy.aiChatRestaurants || {};
  const [showMenuFor, setShowMenuFor] = useState(null);
  const [showBookTableFor, setShowBookTableFor] = useState(null);
  const [userLocation, setUserLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const [page, setPage] = useState(1);
  const limit = 6;
  const navigate = useNavigate();

  const {
    data: searchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["restaurants", userLocation, page, limit, filterType],
    queryFn: () =>{
      // alert('fefefefe')
      return getRestaurantsOrHotels({
        hotels: filterType?.hotels || false,
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
        page,
        limit,
        food:filterType?.foodType,
        location:filterType?.location
      })
    },
      
    keepPreviousData: true,
  });

  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         setUserLocation({
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude,
  //         });
  //       },
  //       (error) => console.error("Location error:", error)
  //     );
  //   }
  // }, []);

  // 🔹 If "View Menu" was clicked → render Menu directly
  if (showMenuFor) {
    return (
      <div className="container py-10">
        <button
          onClick={() => setShowMenuFor(null)}
          className="mb-6 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          ← Back to Restaurants
        </button>
        <Menu restaurantId={showMenuFor} /> {/* 👈 pass only restaurantId */}
      </div>
    );
  }

  if (showBookTableFor) {
    return (
      <div className="container py-10">
        <button
          onClick={() => setShowBookTableFor(null)}
          className="mb-6 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          ← Back to Restaurants
        </button>
        <BookTable restaurantId={showBookTableFor} />{" "}
        {/* 👈 pass only restaurantId */}
      </div>
    );
  }

  const isHotels = filterType?.hotels === true;
  
  return (
    <div className="container py-10">
      <h2 className="text-2xl font-bold mb-6">{isHotels ? (aiCopy.nearbyHotelsTitle || "Nearby Hotels") : (aiCopy.nearbyTitle || "Nearby Restaurants")}</h2>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : isError ? (
        <p className="text-red-500 text-center mt-6">{error.message}</p>
      ) : searchedData?.data?.data?.length > 0 ? (
        <div className="flex flex-col gap-6">
          {searchedData.data.data.map((item) => (
            <div
              key={item?._id}
              className="rounded-lg bg-white border border-gray-200 shadow"
            >
              <img
                src={item?.images?.[0]}
                alt={item?.name}
                className="w-full h-56 object-cover rounded-t-lg"
              />

              <div className="p-4">
                <h3 className="text-xl font-semibold">{item?.name}</h3>
                <p className="text-sm text-gray-600">{item?.address}</p>

                <div className="flex items-center gap-1 mt-2">
                  {Array(Math.floor(item?.rating))
                    .fill()
                    .map((_, i) => (
                      <MdStar key={i} className="text-yellow-500" />
                    ))}
                  {item?.rating % 1 !== 0 && (
                    <MdStarHalf className="text-yellow-500" />
                  )}
                  {Array(5 - Math.ceil(item?.rating))
                    .fill()
                    .map((_, i) => (
                      <MdStarOutline key={i} className="text-yellow-500" />
                    ))}
                </div>

                {item?.distance && (
                  <p className="text-green-600 text-sm mt-2">
                    {item?.distance} km away
                  </p>
                )}

                <div className="flex gap-3 mt-4">
                  <button
                    onClick={() => setShowMenuFor(item._id)}
                    className="flex-1 py-2 px-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    View Menu
                  </button>

                  {/* {item?.menuOnlyMode ? null : (
                    <button
                      onClick={() => setShowBookTableFor(item._id)}
                      className="flex-1 py-2 px-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                      Book Table
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-center">{isHotels ? (aiCopy.noHotelsFound || "No Hotels found") : (aiCopy.noResults || "No Restaurants found")}</p>
      )}
    </div>
  );
};

export default RestaurantOrdering;
